/**
 * statusBar.js
 *
 * Matches the native status bar's icon colour to the resolved theme.
 *
 * capacitor.config.ts sets a fixed Style.Light (dark icons) at launch, which
 * only suits the app's light background. Dark mode, and the dark splash
 * screen, use a near-black background, so those dark icons became invisible
 * against it, hiding the time, battery and signal indicators.
 *
 * On web the plugin is a no-op, so this is safe to call on every platform.
 */
import { Capacitor } from '@capacitor/core';
import { StatusBar, Style } from '@capacitor/status-bar';

export async function syncStatusBarStyle(theme) {
  if (!Capacitor.isNativePlatform()) return;
  try {
    await StatusBar.setStyle({ style: theme === 'dark' ? Style.Dark : Style.Light });
  } catch {
    // Plugin unavailable; nothing to recover from on a user's device.
  }
}
